export default {"src":"/_next/static/media/email.a257bf33.svg","height":24,"width":25};